import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mj-process-step',
  templateUrl: './process-step.component.html',
  styleUrls: ['./process-step.component.scss'],
})
export class ProcessStepComponent implements OnInit {
  @Input() step;
  @Output() processChanged = new EventEmitter();
  @Output() blurChanged = new EventEmitter<boolean>();
  @Input() stepOpenedUuid$;

  constructor() {}

  ngOnInit() {}
}
